import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import StatsPanelItem from 'components/stats-panel-item';
import Tooltip from '@99designs/react-components/components/Tooltip';

export default class ResponsivenessScoreStatsPanelItem extends React.Component {
    formatScore() {
        return this.props.score * 0.01;
    }

    message() {
        return (
            <Tooltip tooltip={<FormattedMessage id="responsiveness_score_tooltip" />}>
                {this.statsPanelItem()}
            </Tooltip>
        );
    }

    statsPanelItem() {
        return (
            <StatsPanelItem
                value={<FormattedNumber style={'percent'} value={this.formatScore()} />}
                title={<FormattedMessage id="responsiveness_score" />}
            />
        );
    }

    render() {
        if (this.props.score !== null) {
            return (
                <span>
                    {this.message()}
                </span>
            );
        }
        return null;
    }
}

ResponsivenessScoreStatsPanelItem.propTypes = {
    score: PropTypes.number,
};

ResponsivenessScoreStatsPanelItem.defaultProps = {
    score: null,
};



// WEBPACK FOOTER //
// ./src/js/apps/responsiveness-score/components/responsiveness-score-stats-panel-item.jsx